<div class="payment-integrations-table-wrapper">
  <p-table
    [value]="items"
    [loading]="loading"
    [lazy]="true"
    [paginator]="true"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [first]="first"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} integrations"
    [scrollable]="true"
    [scrollHeight]="scrollHeight"
    scrollDirection="both"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    responsiveLayout="stack"
    breakpoint="768px"
    size="small"
    appendTo="body"
    [paginatorDropdownAppendTo]="'body'"
    styleClass="p-datatable-payment-integrations"
    dataKey="Id"
    (onLazyLoad)="onLazyLoad($event)"
    (onPage)="onPageChange($event)"
  >
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th
          pFrozenColumn
          [frozen]="true"
          alignFrozen="left"
          pSortableColumn="Id"
          style="width: 4rem"
        >
          ID
          <p-sortIcon field="Id" />
        </th>
        <th pSortableColumn="PaymentMethodType" style="min-width: 150px">
          Provider
          <p-sortIcon field="PaymentMethodType" />
        </th>
        <th style="min-width: 180px">API Account</th>
        <th style="min-width: 180px">API Key</th>
        <th pSortableColumn="TestMode" style="width: 80px">
          Mode
          <p-sortIcon field="TestMode" />
        </th>
        <th pSortableColumn="CreatedUtc" style="width: 100px">
          Created
          <p-sortIcon field="CreatedUtc" />
        </th>
        <th
          pFrozenColumn
          [frozen]="true"
          alignFrozen="right"
          style="width: 3rem; text-align: center"
        >
          Actions
        </th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-item>
      <tr class="data-row">
        <!-- ID Column - Frozen Left, Clickable link to edit -->
        <td pFrozenColumn [frozen]="true" alignFrozen="left" class="id-column">
          <span class="p-column-title">ID</span>
          <a
            href="javascript:;"
            class="id-link"
            (click)="onIdClick(item); $event.stopPropagation()"
          >
            {{ item.Id }}
          </a>
        </td>

        <!-- Provider -->
        <td class="provider-column">
          <span class="p-column-title">Provider</span>
          <span class="provider-cell">
            {{ getProviderDisplayName(item.PaymentMethodType) }}
          </span>
        </td>

        <!-- API Account -->
        <td class="account-column">
          <span class="p-column-title">API Account</span>
          <span
            class="masked-value"
            [pTooltip]="item.ApiAccount ? 'Click to reveal (coming soon)' : ''"
            tooltipPosition="top"
          >
            {{ maskValue(item.ApiAccount) }}
          </span>
        </td>

        <!-- API Key -->
        <td class="key-column">
          <span class="p-column-title">API Key</span>
          <span
            class="masked-value"
            [pTooltip]="item.ApiKey1 ? 'Click to reveal (coming soon)' : ''"
            tooltipPosition="top"
          >
            {{ maskValue(item.ApiKey1) }}
          </span>
        </td>

        <!-- Test Mode -->
        <td class="mode-column">
          <span class="p-column-title">Mode</span>
          <p-tag
            [value]="getTestModeLabel(item.TestMode)"
            [severity]="getTestModeSeverity(item.TestMode)"
            styleClass="mode-tag"
          />
        </td>

        <!-- Created -->
        <td class="created-column">
          <span class="p-column-title">Created</span>
          <span class="date-cell">
            {{ item.CreatedUtc | date: "MMM d, yyyy" }}
          </span>
        </td>

        <!-- Actions - Frozen Right -->
        <td
          pFrozenColumn
          [frozen]="true"
          alignFrozen="right"
          class="actions-column"
        >
          <button
            pButton
            type="button"
            icon="pi pi-ellipsis-v"
            class="p-button-rounded p-button-text p-button-sm"
            (click)="toggleRowMenu($event, item)"
            pTooltip="Actions"
            tooltipPosition="left"
          ></button>
        </td>
      </tr>
    </ng-template>

    <!-- Loading Body (Skeleton) -->
    <ng-template pTemplate="loadingbody">
      <app-table-skeleton-rows [rows]="5" [columns]="skeletonColumns" />
    </ng-template>

    <!-- Empty Message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center py-8">
          <div class="empty-state">
            <i class="pi pi-credit-card text-4xl text-gray-300 mb-3"></i>
            <p class="text-gray-500 mb-0">No payment integrations found</p>
            <p class="text-gray-400 text-sm">
              Try adjusting your filters<br />or create a new integration
            </p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Context Menu -->
  <p-menu
    #contextMenu
    [popup]="true"
    [model]="contextMenuItems"
    appendTo="body"
  />
</div>
